var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newUpdate" }, [
    _c("div", { staticClass: "new_update_title" }, [
      _vm._v("ES6购车核心知识更新")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "new_update_issue" },
      [
        _c("div", { staticClass: "new_update_issue_title" }, [
          _vm._v("常见问题(" + _vm._s(_vm.newUpdateIssue.length) + ")")
        ]),
        _vm._v(" "),
        _vm._l(_vm.newUpdateIssue, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "new_update_item",
              class: { isExpired: item.isExpired },
              on: {
                click: function($event) {
                  return _vm.clickItem(item)
                }
              }
            },
            [
              _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(item.name) +
                    "\n                 "
                ),
                item.isExpired
                  ? _c("span", { staticClass: "isExpired_show" }, [
                      _vm._v("已过期")
                    ])
                  : _vm._e()
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "new_update_space" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "new_update_issue" },
      [
        _c("div", { staticClass: "new_update_issue_title" }, [
          _vm._v("知识点(" + _vm._s(_vm.newUpdateKnowledge.length) + ")")
        ]),
        _vm._v(" "),
        _vm._l(_vm.newUpdateKnowledge, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "new_update_item",
              class: { isExpired: item.isExpired },
              on: {
                click: function($event) {
                  return _vm.clickItem(item)
                }
              }
            },
            [
              _c("div", [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.name) +
                    "\n                    "
                ),
                item.isExpired
                  ? _c("span", { staticClass: "isExpired_show" }, [
                      _vm._v("已过期")
                    ])
                  : _vm._e()
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3da8415f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3da8415f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/newUpdate.vue
// module id = null
// module chunks = 